// import SocialIcon from '../assets/icons/highlights-icons/social.svg';

const highlightPageDataAr = {
    header : {
        title : "أبرز النقاط 2022",
        subtitle : "ساهم بنك الأول، منذ يومه الأول، بدور حيوي في دفع عجلة النمو الاقتصادي والتقدم المجتمعي في المملكة. واليوم، نتحمل المسؤولية بأن نؤدي دورنا المحوري لتحقيق الفرق الحقيقي والدائم لبيئتنا ومجتمعاتنا وأصحاب المصلحة الذين تربطهم علاقة بنا. ونستعرض في السطور التالية بعض أبرز النقاط الرئيسية التي توضح تأثير جهود الأول على الجوانب الحوكمة البيئية والاجتماعية والمؤسسية:",
        image : {
            name : "highlight.jpg",
            alt : "Highlight Background",
        }
    },
    sectionOne : {
        title : {
            text : "الجوانب الاقتصادية",
            icon : "economic.svg",
        },
        subsectionOne : {
            title : "أول بنك يطلق الودائع الخضراء في المملكة",
            subtitle : "في يناير 2022، أطلق بنك الأول أول منتج للودائع الخضراء في المملكة للسماح للعملاء من الأفراد بإيداع أموالهم بأمان لاستخدامها لتمويل المبادرات الخضراء.",
            label : {
                titleOne : "289 مليون ريال سعودي",
                subtitleOne : "أرصدة",
                titleTwo : "488 عميل من الأفراد",
                subtitleTwo : "مع",
            }
        },
        subsectionTwo : {
            titleOne : "البحر الأحمر للتطوير",
            subtitleOne : "في مارس 2021، تم تكليف بنك الأول كأحد المنظمين الرئيسيين لأول تمويل أخضر لتسهيل التمويل المجمع 14 مليار ريال سعودي لصالح شركة البحر الأحمر للتطوير، وكان إتش إس بي سي منسق القرض الأخضر في الصفقة.",
        },
        subsectionThree : {
            title : "جائزة أفضل بنك للتمويل المستدام في المملكة لعام 2022",
            subtitle : "حصل بنك الأول على جائزة أفضل بنك للتمويل المستدام في المملكة العربية السعودية لعام 2022 من مجلة غلوبال فاينانس كجزء من جوائز التميز السنوية التي حصدها.",
        }
    },
    sectionTwo : {
        title : {
            text : "الجوانب البيئية",
            icon : "environment.svg",
        },
        subsectionOne : {
            title : "مبادرة السعودية الخضراء",
            subtitle : <p>عقد بنك الأول شراكة مع المركز الوطني لتنمية الغطاء النباتي في <b>مبادرة زراعة 10 مليار شجرة</b>. نهدف إلى زراعة مليون شجرة بحلول 2030.</p>,
            label : {
                title : "50,000 شجرة",
                subtitle : "في عام 2022، زرعنا"
            }
        },
        subsectionTwo : {
            title : "برنامج الوصول إلى صافي صفر من الانبعاثات الكربونية*",
            subtitle : "أثمرت مبادرات الأول الخضراء عن:",
            gridOne : [
                {
                    title : "2.6 مليون",
                    subtitle : "توفير",
                    subtitleTwo : "علبة مياه بلاستيكية ذات الاستخدام الواحد"
                },
                {
                    title : "374,926 كجم",
                    subtitle : "إعادة تدوير",
                    subtitleTwo : "من النفايات"
                }
            ],
            gridTwo : [
                {
                    title : "1.7 مليون كيلوواط ساعة",
                    subtitle : "توفير",
                    subtitleTwo : "من الطاقة"
                },
                {
                    title : "221,884",
                    subtitle : "توفير",
                    subtitleTwo : "من المياه على مستوى البنك"
                }
            ]
        },
        subsectionThree : {
            title : "مقر جديد*",
            subtitle : "الحاصل على شهادة الريادة في تصميمات الطاقة والبيئة الذهبية",
            gridOne : [
                {
                    title : "%28.47 ",
                    subtitle : "نسبة الانخفاض في استهلاك الطاقة التشغيلية",
                },
                {
                    title : "%59.25",
                    subtitle : "نسبة تقليل استهلاك المياه للمسطحات الخضراء",
                }
            ],
            gridTwo : [
                {
                    title : "%75",
                    subtitle : "نسبة نفايات البناء المعاد تدويرها"
                },
                {
                    title : "%54.3",
                    subtitle : "نسبة تقليل استهلاك المياه في الأماكن المغلقة"
                }
            ]
        },
        note : "* الأرقام المذكورة أعلاه تم احتسابها على أساس سنوي"
    },
    sectionThree : {
        title : {
            text : "الجوانب الاجتماعية",
            icon : "social.svg",
        },
        subsectionOne : {
            title : 'برنامج "ريالي" للوعي المالي',
            subtitle : "إطلاق مسابقة للتثقيف والوعي المالي خلال الربع الأول بالتعاون مع وزارة التعليم.",
            label : {
                title : "370,000",
                subtitleOne : "أكثر من",
                subtitleTwo : " طالب وطالبة شاركوا عبر المملكة."
            }
        },
        subsectionTwo : {
            title : "تمثيل المرأة في البنك",
            subtitle : "يخطو البنك خطوات جيدة في مجال التّنوع بين الجنسين",
            label : {
                title : "%35.7",
                subtitleOne : "بلغت نسبة تمثيل المرأة",
                subtitleTwo : "في فريق الإدارة التنفيذية. "
            }
        },
        subsectionThree : {
            title : 'برنامج "تقدم"',
            subtitle : "اختتمت النسخة الرابعة من برنامج تسريع الأعمال الناشئة.",
            gridOne : [
                {
                    title : "10 فائزين",
                },
                {
                    title : "57 فريقاً",
                    subtitle : " شاركوا (112 شخصاً)."
                }
            ]
        },
        subsectionFour : {
            title : "برنامج مُسرعات لذوي الاحتياجات الخاصة",
            subtitle : "بالتعاون مع منشآت ووزارة العمل.عُقدت الجلسات بحضور",
            label : {
                title : "23,093",
                subtitle : "متدرباً في بيئة مختلطة."
            },
        },
        subsectionFive : {
            title : "أكاديمية الأول الرقمية",
            subtitle : "تدعم أكاديمية الأول الرقمية دخول الشباب إلى سوق العمل من خلال التدريب وتنمية المهارات المالية.",
            label : {
                title : "1,200",
                subtitleOne : "في عام 2022، شارك",
                subtitleTwo : "مستفيد."
            }
        },
        subsectionSix : {
            title : "إطلاق مشروعي حفظ فائض الأغذية الجافة ومنع الهدر",
            subtitle : "في عام 2022:",
            gridOne : [
                {
                    title : "400,000",
                    subtitleOne : "توفير",
                    subtitleTwo : "وجبة.",
                },
                {
                    title : "130 ",
                    subtitleOne : "حفظ",
                    subtitleTwo : "طن من المواد الغذائية.",
                },
                {
                    subtitleOne : "دعم",
                    title : "6,000",
                    subtitleTwo : "أسرة لمدة ستة أشهر."
                }
            ]
        }
    },
    sectionFour : {
        title : {
            text : "الحوكمة",
            icon : "governance.svg",
        },
        subsectionOne : {
            title : "تعزيز إطارنا الخاص بالممارسات البيئية والاجتماعية والحوكمة المؤسسية",
            subtitle : <p><b>نفذنا هيكل الممارسات البيئية والاجتماعية والحوكمة المؤسسية،</b> بما في ذلك تشكيل لجنة توجيهية جديدة للممارسات البيئية والاجتماعية والحوكمة المؤسسية للإشراف على تنفيذ استراتيجية بنك الأول للممارسات البيئية والاجتماعية والحوكمة المؤسسية.</p>,
        },
        subsectionTwo : {
            title : "جائزة برنامج التميز في المشتريات (PEP)",
            subtitle : <p>حصل بنك الأول <b>على هذه الجائزة المقدمة من المعهد القانوني للشراء والتوريد (CIPS)</b> في عام 2023.</p>,
        },
        subsectionThree : {
            title : "منتدى مصرفية الشركات والمؤسسات للتمويل المستدام",
            subtitle : <p>يشرف منتدى مصرفية الشركات والمؤسسات للتمويل المستدام الجديد لبنك الأول <b>على الإقراض المستدام.</b></p>,
        },
        subsectionFour : {
            title : "مبادئ الأمم المتحدة للخدمات المصرفية المسؤولة (UNPRB)",
            subtitle : <p>بنك الأول هو أول بنك في المملكة يوقع على مبادئ الخدمات المالية المسؤولة، وهي جزء من المبادرة المالية لبرنامج الأمم المتحدة للبيئة.</p>,
        },
        subsectionFive : {
            title : "رواد الممارسات البيئية والاجتماعية والحوكمة المؤسسية",
            subtitle : <p>تعيين وإعداد<b> 35 من رواد الممارسات البيئية والاجتماعية والحوكمة المؤسسية</b> عبر الأول.</p>
        },
        subsectionSix : {
            title : "لجان الإدارة",
            subtitle : <p>خفض بنك الأول عدد لجان الإدارة من<b> 40 إلى 24 لجنة</b> تركز على الآثار الاقتصادية والبيئية والاجتماعية، بما يتوافق مع اللوائح وأفضل الممارسات.</p>
        }
    }
}

export default highlightPageDataAr;